import type { TPhysicsWorldConfig, TPhysicsWorldParams } from '@Anarchy/Engine/Physics/Models';

export function physicsWorldConfigToParams(config: TPhysicsWorldConfig): TPhysicsWorldParams | never {
  return config;
}
